<template>
  <Layout>
    <div class="section content has-text-white">
      <h1 class="is-size-5 has-text-primary">{{ $t('Imprint') }}</h1>
      <span class="is-size-7">
        <p>
          Гамесманиацлоунге је заштитни знак компаније Business Fleet s.r.o.<br>
          ПДВ број: CZ24814776<br>
          Адреса:  Business Fleet s.r.o., Lidická 700/19, Veveří, 602 00 Brno, Češka<br>
          Емаил: <a class="has-text-primary" href="mailto:keepyoufit.rs@silverlines.info">keepyoufit.rs@silverlines.info</a><br>
          Тел: <a class="has-text-primary" href="tel:0113216815">0113216815</a><br>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/RS/Imprint.vue